
import { directionStatus } from '@gmg/gmg-react-components';
import { useContext } from 'react';
import AppContext from '../AppContext';

const useSort = () => {
    const { language } = useContext(AppContext);
    const currentLanguage = language.length ? language : 'en';

    const getSortingValue = (result: number, direction: directionStatus) => {
        if (result === 0) return 0;
        return direction === 'ASC' ? result : result * -1;
    };

    const getSortFn = (propertyName: string, direction: directionStatus) => {
        return (a: any, b: any) => {

            if (propertyName === 'cpGo') { //special case. i do not want to change the sort structure for that just now
                const aActive = a.cpGo?.isLicensed && a.cpGo?.isOnline;
                const bActive = b.cpGo?.isLicensed && b.cpGo?.isOnline;

                const aVal = aActive ? 1 : 0;
                const bVal = bActive ? 1 : 0;

                const result = aVal - bVal;
                return getSortingValue(result, direction);
            }

            const aValue = a[propertyName];
            const bValue = b[propertyName];
            const result = aValue?.toString().localeCompare(bValue?.toString(), currentLanguage);
            return getSortingValue(result, direction);

        };
    };

    const getSortStringsFn = (direction: directionStatus) => {
        return (a: string, b: string) => {

            const result = a.localeCompare(b, currentLanguage);
            return getSortingValue(result, direction);

        };
    };

    return { getSortFn, getSortStringsFn };
};
export default useSort;